import messages from './messages';

export const formatTransferStateDescription = (str='') => (
  messages[`transferState${str}`] ? messages[`transferState${str}`].defaultMessage : ''
);



// WEBPACK FOOTER //
// ./src/components/TransferStateDescriptionModal/formatters.js